import { createRoot } from "react-dom/client";
import { I18nextProvider } from 'react-i18next';
import { Main } from "./Main";
import i18n from './i18n/config';

// HMR Error Handler - Track React Refresh stack overflows
if (process.env.NODE_ENV === "development") {
  window.addEventListener("error", (event) => {
    if (event.message?.includes("Maximum call stack size exceeded")) {
      const stack = event.error?.stack || "";
      const isReactRefresh = stack.includes("computeFullKey") || stack.includes("react-refresh");

      if (isReactRefresh) {
        console.error(
          "%c[HMR] React Refresh Stack Overflow Detected",
          "color: red; font-weight: bold; font-size: 14px;",
          "\n\nThis is likely caused by circular hook dependencies.",
          "\n\nFiles with module.hot.decline() should reload the full page.",
          "\nIf you're seeing this, a file not yet protected is causing the issue.",
          "\n\nStack trace:",
          stack
        );
      }
    }
  });
}

// Set favicon based on domain
const setFavicon = () => {
  const link = document.querySelector("link[rel*='icon']") as HTMLLinkElement;

  if (link && window.location.hostname === "staging.airplx.com") {
    // Use the staging favicon directly
    link.href = "./favicon-staging.png";
  }
};

// Set favicon on load
setFavicon();

const app = document.getElementById("app");

if (app) {
  const root = createRoot(app);
  root.render(
    <I18nextProvider i18n={i18n}>
      <Main />
    </I18nextProvider>
  );
}
